export const SNAPSHOT_VIEW_TAGS = {
  SNAPSHOT_VIEWS: "SnapshotViews",
  SNAPSHOT_VIEW_FAVORITES: "SnapshotViewFavorites",
} as const;
